import { configureAnalytics } from '@consolidocs-ui/analytics';

declare const __APP_VERSION__: string;

// Side-effect module, imported at the top of main.tsx next to apiRuntime, so
// tracking is set up before anything can record an event. With no token for
// the environment every analytics call is a no-op.
configureAnalytics({
  token: import.meta.env.VITE_MIXPANEL_TOKEN,
  apiHost: import.meta.env.VITE_MIXPANEL_API_HOST,
  environment: import.meta.env.VITE_MIXPANEL_ENV,
  app: 'main',
  version: __APP_VERSION__,
  debug: import.meta.env.DEV,
});
